import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, KeepAlive as _KeepAlive, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-156a8390")

_pushScopeId("data-v-156a8390")
const _hoisted_1 = {
  key: 0,
  class: "alert alert-info",
  "data-cy": "PayPortal.PaymentOptions.AlreadyDeferredAlert"
}
const _hoisted_2 = {
  key: 1,
  class: "alert alert-info",
  "data-cy": "PayPortal.PaymentOptions.Alert"
}
const _hoisted_3 = { "data-cy": "PayPortal.PaymentOptions.Heading" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "options" }
const _hoisted_10 = {
  key: 0,
  "data-cy": "PayPortal.PaymentOptions.DeferPayment"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" If you'd prefer to start with temporary access you can get a ")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "well paynow",
  "data-cy": "PayPortal.PaymentOptions.PayNow"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("h2", { "data-cy": "PayPortal.PaymentOptions.PayNowHeading" }, "Pay now", -1)
const _hoisted_15 = { "data-cy": "PayPortal.PaymentOptions.PayNowDetails" }
const _hoisted_16 = {
  key: 2,
  class: "well redemption",
  "data-cy": "PayPortal.PaymentOptions.RedemptionCode"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("h2", { "data-cy": "PayPortal.PaymentOptions.RedemptionCodeHeading" }, "Use a code", -1)
const _hoisted_18 = { "data-cy": "PayPortal.PaymentOptions.RedemptionCodeDetails" }
const _hoisted_19 = { key: 3 }
_popScopeId()

import { ContentAndStudent, ContentAvailability, EmailValues, PrivateLabels, StudentInfo } from "@/modules/backend"
import { Ref, ref, shallowRef } from "vue"
import { prettyMoney, daysUntil, monthsUntil } from "../modules/frontend"
import DeferPayment from "./DeferPayment.vue"
import Paypal from "./Paypal.vue"
import RedemptionCode from "./RedemptionCode.vue"
import { prop } from "vue-class-component"


export default _defineComponent({
  expose: [],
  props: {
    className: { type: String, required: true },
    contentAndStudent: { type: null, required: true },
    availability: { type: null, required: true },
    studentInfo: { type: null, required: true },
    privateLabels: { type: null, required: true },
    tenantName: { type: String, required: true },
    tenantPaymentUrl: { type: String, required: true },
    tenantRedemptionUrl: { type: String, required: true },
    ltiIdToken: { type: [String, null], required: true },
    ltiState: { type: [String, null], required: true },
    emailValues: { type: null, required: true }
  } as unknown as undefined,
  emits: ['success', 'error'],
  setup(__props: {
	className: string
	contentAndStudent: ContentAndStudent
	availability: ContentAvailability
	studentInfo: StudentInfo
	privateLabels: PrivateLabels
	tenantName: string
	tenantPaymentUrl: string
	tenantRedemptionUrl: string
	ltiIdToken: string | null
	ltiState: string | null
	emailValues: EmailValues
}, { emit }) {

const props = __props





const paypalOption = props.availability.paymentOptions.paypal
const deferredOption = props.availability.paymentOptions.deferred
const redemptionCodeOption = props.availability.paymentOptions.redemptionCode


const alreadyDeferred = props.availability.studentTransactions.alreadyDeferred
const expiry = props.availability.studentTransactions.existingLicenseExpiry
const daysLeft = expiry != null ? daysUntil(expiry) : "<unknown>"

const selectedOption: Ref<object | null> = shallowRef(null)
const optionProps: Ref<object | null> = ref(null)

const queryParam = new URLSearchParams(window.location.search).get('redemption_code') // Replace 'queryParam' with the actual parameter name
if (queryParam) {
	// Handle the query parameter here
	showRedemptionCodeScreen()
}

function showRedemptionCodeScreen() {
	if (props.tenantRedemptionUrl && props.tenantRedemptionUrl.length > 0) {
		// Redirect to the tenant payment URL
		const destination = props.tenantRedemptionUrl 
			+ "?email=" + encodeURIComponent(props.studentInfo.emailAddress)
			+ "&name=" + encodeURIComponent(props.studentInfo.name)
			+ "&course_id=" + encodeURIComponent(props.className)
			+ "&class_id=" + props.contentAndStudent.contentId.classId
			+ "&return_url=" + encodeURIComponent(window.location.href)
			+ "&lti_id_token=" + encodeURIComponent(props.ltiIdToken || "")
			+ "&lti_state=" + encodeURIComponent(props.ltiState || "")
		
		window.location.href = destination
		return
	}
	optionProps.value = {
		redemptionCodeOption: props.availability.paymentOptions.redemptionCode,
		contentAndStudent: props.contentAndStudent,
		emailValues: props.emailValues
	}
	selectedOption.value = RedemptionCode
}

function showDeferredScreen() {
	optionProps.value = {
		deferred: props.availability.paymentOptions.deferred,
		contentAndStudent: props.contentAndStudent,
		emailValues: props.emailValues
	}
	selectedOption.value = DeferPayment
}

function showPaypalScreen() {
	if (props.tenantPaymentUrl && props.tenantPaymentUrl.length > 0) {
		// Redirect to the tenant payment URL
		const returnUrl = window.location.href
		const destination = props.tenantPaymentUrl 
			+ "?email=" + encodeURIComponent(props.studentInfo.emailAddress )
			+ "&name=" + encodeURIComponent(props.studentInfo.name)
			+ "&course_id=" + encodeURIComponent(props.className)
			+ "&class_id=" + props.contentAndStudent.contentId.classId
			+ "&return_url=" + encodeURIComponent(returnUrl)
			+ "&lti_id_token=" + encodeURIComponent(props.ltiIdToken || "")
			+ "&lti_state=" + encodeURIComponent(props.ltiState || "")
		window.location.href = destination
		return
	}
	optionProps.value = {
		className: props.className,
		paypal: props.availability.paymentOptions.paypal,
		contentAndStudent: props.contentAndStudent,
		studentInfo: props.studentInfo,
		privateLabels: props.privateLabels,
		tenantName: props.tenantName
	}
	selectedOption.value = Paypal
}

function showOptions() {
	selectedOption.value = null
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", null, [
    (_unref(alreadyDeferred))
      ? (_openBlock(), _createBlock("p", _hoisted_1, " Your temporary license expires in " + _toDisplayString(_unref(daysLeft)) + " days.", 1))
      : (_openBlock(), _createBlock("p", _hoisted_2, "You need a license to access this content.")),
    _createVNode("h1", _hoisted_3, _toDisplayString(__props.className), 1),
    _hoisted_4,
    (_unref(selectedOption) == null)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          (_unref(deferredOption) == null)
            ? (_openBlock(), _createBlock("p", _hoisted_6, " You can purchase a license. "))
            : (_openBlock(), _createBlock("p", _hoisted_7, " Please select one of the following options to acquire a license: ")),
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            (_unref(deferredOption))
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("p", null, [
                    _hoisted_11,
                    _createVNode("a", {
                      class: "link-button",
                      "data-cy": "PayPortal.PaymentOptions.DeferPaymentLink",
                      onClick: _withModifiers(showDeferredScreen, ["prevent"])
                    }, "temporary license", 8, ["onClick"]),
                    _createTextVNode(" that lasts for " + _toDisplayString(_unref(daysUntil)(_unref(deferredOption).expiry)) + " days and complete your payment later to continue using Möbius beyond that period. ", 1)
                  ]),
                  _hoisted_12
                ]))
              : _createCommentVNode("", true),
            (_unref(paypalOption))
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  _createVNode("div", null, [
                    _hoisted_14,
                    _createVNode("p", _hoisted_15, "Pay " + _toDisplayString(_unref(prettyMoney)(_unref(paypalOption).price)) + " online by credit card or PayPal to get a " + _toDisplayString(_unref(monthsUntil)(_unref(paypalOption).expiry)) + "-month license. ", 1)
                  ]),
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-default",
                    onClick: showPaypalScreen,
                    "data-cy": "PayPortal.PaymentOptions.PayNowButton"
                  }, "Pay now")
                ]))
              : _createCommentVNode("", true),
            (_unref(redemptionCodeOption))
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("div", null, [
                    _hoisted_17,
                    _createVNode("p", _hoisted_18, "If you already have a code from your school, you can use this option to redeem your code now and get a " + _toDisplayString(_unref(monthsUntil)(_unref(redemptionCodeOption).expiry)) + "-month license.", 1)
                  ]),
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-default",
                    onClick: showRedemptionCodeScreen,
                    "data-cy": "PayPortal.PaymentOptions.RedemptionCodeButton"
                  }, "Redeem code")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_19, [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(selectedOption)), _mergeProps(optionProps.value, {
              onOtherOptions: showOptions,
              onSuccess: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('success'))),
              onError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('error')))
            }), null, 16))
          ], 1024))
        ]))
  ]))
}
}

})